import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LabeledTextboxComponent } from './labeled-textbox.component';



@NgModule({
    declarations: [
        LabeledTextboxComponent,
    ],
    exports: [
        LabeledTextboxComponent,
    ],
    imports: [
        CommonModule,
    ],
})
export class LabeledTextboxModule { }
